import type { NurseInShift, PrintoutSchedule } from "../../../utils/models";
import { buildNurseNotes } from "../../../utils/utilFunctions";
import type { RowNoteFlags } from "../types";

interface ComposeRowNotesArgs {
	nurse: NurseInShift | null | undefined;
	hospitalData: PrintoutSchedule;
	flags: RowNoteFlags | undefined;
}

/**
 * Compose the Notes cell value for a staff row (mapping §9.1).
 *
 * Delegates to the shared `buildNurseNotes` helper. The flags `includeAgency` / `includeNotOnboarded`
 * default to **on** when undefined (mapping §11.6) — that defaulting is enforced upstream by
 * `buildNoteFlags` in `phases/renderSheets.ts`, so this module just passes through whatever it gets.
 */
export const composeRowNotes = ({ nurse, hospitalData, flags }: ComposeRowNotesArgs): string => {
	return buildNurseNotes(nurse, hospitalData, flags);
};
